import { Loader } from '@googlemaps/js-api-loader';

import * as Cookie from './cookie';
import * as Form from './form';

const formElement = document.querySelector('[data-closest-container-form]');
const formResults = document.querySelector('[data-closest-container-results]');
const noticeElement = document.querySelector('[data-notice]');
const googleMap = document.querySelector('[data-closest-container-google-map]');
const markers = [];
const containerLocations = [];
let activeWindow = null;

export function setMarkers(map) {
    Object.keys(containerLocations)
        .forEach((item) => {
            const containerLocation = containerLocations[item];
            /* eslint-disable no-undef */
            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(containerLocation[1], containerLocation[2]),
                map,
                icon: '/img/custom/markers/default.png',
            });

            const infoWindow = new google.maps.InfoWindow({
                content: `<strong class="font-bold m-3">${containerLocation[0]}</strong>`,
            });

            google.maps.event.addListener(marker, 'click', () => {
                if (activeWindow) {
                    activeWindow.close();
                }

                infoWindow.open({
                    anchor: marker,
                    map,
                    shouldFocus: false,
                });

                activeWindow = infoWindow;
            });
            /* eslint-enable no-undef */

            markers.push(marker);
        });
}

export function initMap() {
    googleMap.classList.remove('hidden');

    /* eslint-disable no-undef */
    const mapsConfig = {
        mapTypeId: 'roadmap',
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: [
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ]
    };

    // Set zoom level of map
    mapsConfig.zoom = 13;

    // Center map based on first found container
    // Also make sure the waste type parameter can be found in the data of the gpscontainers
    const wasteTypeParameter = formElement.querySelector('[name="waste-type"]').value;
    const allowedWasteTypes = ['glas', 'kca', 'papier', 'restafval', 'textiel', 'vet'];
    if (containerLocations.length > 0 && containerLocations[0][1] && containerLocations[0][2] && allowedWasteTypes.includes(wasteTypeParameter)) {
        mapsConfig.center = {
            lat: parseFloat(containerLocations[0][1]),
            lng: parseFloat(containerLocations[0][2]),
        };
    } else {
        // When no containers found, center map on municipality
        switch (Cookie.get('municipality')) {
        case 'maasgouw':
        default:
            mapsConfig.center = {
                lat: 51.1578524,
                lng: 5.8120301,
            };
            break;
        case 'leudal':
            mapsConfig.center = {
                lat: 51.2339537,
                lng: 5.8084257,
            };
            break;
        case 'roerdalen':
            mapsConfig.center = {
                lat: 51.1454765,
                lng: 5.976965,
            };
            break;
        case 'beesel':
            mapsConfig.center = {
                lat: 51.2923433,
                lng: 6.0888222,
            };
            break;
        }
    }

    if (window.innerWidth <= 768) {
        mapsConfig.draggable = true;
        mapsConfig.zoomControl = true;
    }

    const map = new google.maps.Map(googleMap, mapsConfig);
    /* eslint-enable no-undef */

    setMarkers(map);
}

export function addContents(json) {
    let formResultsHtml = '<ul>';

    if (json.length > 0) {
        Object.keys(json)
            .forEach((item) => {
                // eslint-disable-next-line max-len
                containerLocations.push([json[item].address, json[item].latitude, json[item].longitude, 4]);
                formResultsHtml += `<li>${json[item].WasteType}: ${json[item].address}</li>`;
            });
    }

    formResultsHtml += '</ul>';
    //formResults.innerHTML = formResultsHtml;

    initMap();

    Cookie.set('postal-code', formElement.querySelector('[name="postal-code"]').value);
    Cookie.set('house-number', formElement.querySelector('[name="house-number"]').value);
    Cookie.set('house-number-addition', formElement.querySelector('[name="house-number-addition"]').value);
}

export function resetForm() {
    formResults.innerHTML = '';
    googleMap.innerHTML = '';
    googleMap.classList.add('hidden');

    Form.hideNotice(formElement, noticeElement);
}

export function sendFormData() {
    const Request = new XMLHttpRequest();
    Request.open(formElement.method, formElement.action);
    Request.setRequestHeader('Accept', 'application/json');
    formElement.setAttribute('aria-busy', 'true');

    resetForm();

    let called = false;
    Request.onreadystatechange = () => {
        if (Request.readyState === XMLHttpRequest.DONE && !called) {
            if (Request.status === 0 || (Request.status >= 200 && Request.status < 400)) {
                const jsonResponse = JSON.parse(Request.responseText);

                if (jsonResponse.invalidPostalCode) {
                    Form.showNotice(noticeElement, 'Deze postcode bevindt zich buiten uw geselecteerde gemeente, pas uw geselecteerde gemeente aan.');
                } else {
                    addContents(JSON.parse(Request.responseText));
                }
            } else if (this.status === 422) {
                Object.keys(JSON.parse(Request.responseText).errors)
                    .forEach((item) => {
                        Form.invalidateInputs(item);
                        Form.showNotice(formResults, JSON.parse(Request.responseText).errors[item]);
                    });
            } else {
                Form.showNotice(formResults, 'Er is geen container gevonden voor deze postcode.');
            }

            called = true;
            formElement.setAttribute('aria-busy', 'false');
        }
    };

    Request.send(new FormData(formElement));
}

export default function initClosestContainerSearch() {
    if (formElement) {
        const cookiePostalCode = Cookie.get('postal-code');
        const cookieHouseNumber = Cookie.get('house-number');
        const cookieHouseNumberAddition = Cookie.get('house-number-addition');

        formElement.querySelector('[name="postal-code"]').value = cookiePostalCode;
        formElement.querySelector('[name="house-number"]').value = cookieHouseNumber;
        formElement.querySelector('[name="house-number-addition"]').value = cookieHouseNumberAddition;

        const loader = new Loader({
            apiKey: 'AIzaSyCRyrckY_z9CxzOHzL4-7KoYRY1nSO1sW4',
            language: 'nl_NL',
            version: 'weekly',
        });
        loader.load()
            .then(() => {
                if (cookiePostalCode && cookieHouseNumber) {
                    sendFormData();
                }

                formElement.addEventListener('submit', (e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    sendFormData();
                });
            });
    }
}
